import { render, staticRenderFns } from "./ProgressComponent.vue?vue&type=template&id=6a805d72&scoped=true&"
import script from "./ProgressComponent.vue?vue&type=script&lang=js&"
export * from "./ProgressComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a805d72",
  null
  
)

export default component.exports